<template lang="pug">
    .popup-container(v-if="isHidden")
        .popup-wrapper
            a(href="" @click.prevent="toggle").popup-close
                img(src="@/assets/images/misc/popup-close.svg")

            .activity-popup-wrapper(v-closable="{ exclude: [], handler: 'onClose' }")
                h4 {{ singleActivity.package_name }}
                p.cost USD {{ singleActivity.price }} each

                .activity-inner-wrapper
                    .activity-image(:style="{ backgroundImage: `url(${singleActivity.feature_image.path})` }")
                    .description(v-html="singleActivity.description")

</template>

<script>
    export default {
        name: 'ActivityPopup',
        data() {
            return {
                isHidden: false
            }
        },
        props: ['singleActivity'],
        methods: {
            toggle: function() {
                this.isHidden = !this.isHidden
            },
            onClose: function() {
                this.isHidden = false;
            }
        }
    }
</script>

<style lang="sass" scoped>
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"
    @import "@/assets/css/3-components/_popup-slider.sass"     
</style>


